import { AppThunk } from "../misc"

export enum CELL_DECORATORS_ACTIONS {
  BLINK_CELL_STARTED = "BLINK_CELL_STARTED",
  BLINK_CELL_STOPPED = "BLINK_CELL_STOPPED",
}

export type CELL_ACTION_TYPES = BlinkCellAction

export type BlinkCellAction = {
  type: CELL_DECORATORS_ACTIONS.BLINK_CELL_STARTED | CELL_DECORATORS_ACTIONS.BLINK_CELL_STOPPED
  cellId: number
}

export const doBlinkCell = (cellId: number): AppThunk => dispatch => {
  dispatch( {
    type: CELL_DECORATORS_ACTIONS.BLINK_CELL_STARTED,
    cellId
  });

  return new Promise<void>(resolve => setTimeout(()=>{
    dispatch({
      type: CELL_DECORATORS_ACTIONS.BLINK_CELL_STOPPED,
      cellId
    });

    resolve();
  }, 3000));
}
